module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.spec.items), function(item) {
    return _c('p-radio', {
      attrs: {
        "label": typeof item === 'object' ? item.value : item,
        "disabled": _vm._readonly
      },
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    }, [_vm._v(_vm._s(_vm.i18n.fr(typeof item === 'object' ? item.label : item)) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bbf850c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-radio.vue
// module id = 520
// module chunks = 55